import { render, staticRenderFns } from "./LookupSubColDialogComponent.vue?vue&type=template&id=24e68774&"
import script from "./LookupSubColDialogComponent.vue?vue&type=script&lang=js&"
export * from "./LookupSubColDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports